import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, Type } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { AccordionBlock, AccordionPanel } from '../../../model';
import {
  getIconBgColor,
  parseAccordionIcon,
  ParsedAccordionIcon,
} from '../../../editor/extensions/accordion/accordion-icon.util';

@Component({
  selector: 'dojo-accordion-block-renderer',
  template: `
    <mat-accordion class="custom-mat-accordion mat-accordion--faq mat-accordion" [multi]="true">
      @for (panel of block().panels; track $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              @if (getParsedIcon(panel); as pi) {
                <span
                  class="mr-2"
                  [style.display]="'inline-flex'"
                  [style.align-items]="'center'"
                  [style.justify-content]="'center'"
                  [style.font-size]="'1rem'"
                  [style.width]="pi.showBackground ? '28px' : '20px'"
                  [style.height]="pi.showBackground ? '28px' : '20px'"
                  [style.border-radius]="pi.showBackground ? '6px' : null"
                  [style.background-color]="pi.showBackground ? getIconBgColor(pi.color) : null"
                >
                  @switch (pi.type) {
                    @case ('emoji') {
                      {{ pi.value }}
                    }
                    @case ('fa') {
                      <i [class]="'fas fa-' + pi.value" [style.color]="pi.color" style="font-size: 16px"></i>
                    }
                    @case ('img') {
                      <img [src]="pi.value" alt="" style="width: 18px; height: 18px; object-fit: contain" />
                    }
                  }
                </span>
              }
              {{ panel.title }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="p-4">
            <ng-container *ngComponentOutlet="contentRenderer(); inputs: { blocks: panel.content }" />
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionModule, NgComponentOutlet],
})
export class AccordionBlockRendererComponent {
  readonly block = input.required<AccordionBlock>();
  readonly contentRenderer = input.required<Type<unknown>>();

  getParsedIcon(panel: AccordionPanel): ParsedAccordionIcon | null {
    return panel.icon ? parseAccordionIcon(panel.icon) : null;
  }

  getIconBgColor(color?: string): string | null {
    return getIconBgColor(color);
  }
}
